// Cspell:ignore sidetab

import { Sidetab } from "@typeform/embed-react";
import { useAtomValue } from "jotai";
import { useRouter } from "next/router";
import type { FunctionComponent } from "react";

import { accountAtom } from "~/lib/account";
import { isString } from "~/lib/utils";
type Props = {
  entityId: string;
};

export const Typeform: FunctionComponent<Props> = ({ entityId }) => {
  const { user } = useAtomValue(accountAtom);
  const { query } = useRouter();

  const renderValue = (value: string | string[] | undefined) => {
    if (Array.isArray(value)) {
      return value.join(", ");
    } else if (isString(value)) {
      return value;
    } else {
      return "";
    }
  };

  return (
    <Sidetab
      buttonColor="#FFCB05"
      buttonText="Share your feedback"
      hidden={{
        utm_campaign: renderValue(query?.utm_campaign),
        utm_content: entityId,
        utm_medium: renderValue(query?.utm_medium),
        utm_source: user?.uuid ?? "",
        utm_term: renderValue(query?.utm_term),
      }}
      id="B2vUPaTF"
      medium="snippet"
      opacity={100}
      hideHeaders
      transitiveSearchParams
    />
  );
};
